<template>
  <div class="full flex-fill">
    <div class="container-fluid">
      <div class="row min-vh-50 g-0 d-flex h-100 ravel">
        <div class="col-md-7 p-3 bg-secondary">
          <div class="row">
            <stat-card
              dictKey="number_outages"
              msg="Current Outages"
              :total-data="totalData"
            />
            <stat-card
              dictKey="customers_affected"
              msg="Customers Affected"
              :total-data="totalData"
            />
          </div>
          <div class="row">
            <div class="col p-3 w-100">
              <div class="card card-body bg-dark">
                <div class="col" id="chart">
                  <AreaChart :areaData="chartData" :areaLabels="chartLabels" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 p-3 bg-secondary">
          <div class="row map-container">
            <Map :mapData="mapData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatCard from "./StatCard.vue"
import AreaChart from "./AreaChart.vue"
import Map from "./Map.vue"

export default {
  components: { StatCard, AreaChart, Map },
  props: {
    chartData: Object,
    chartLabels: Object,
    mapData: Object,
    totalData: Object
  },
  name: "Layout"
}
</script>

<style scoped>
#chart {
  position: relative;
  margin: auto;
  height: 100%;
  width: 100%;
}

.map-container {
  height: 100%;
  min-height: 250px
}

.full {
  height: 100%;
  width: 100%;
}

</style>

